<!--
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-08-02 13:54:50
 * @LastEditTime: 2024-07-01 15:47:19
 * @LastEditors: lijinpeng
-->
<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
        <NfNoticeBar v-if="showNoticeBar" :list="[noticeContent]" />
      </div>
      <app-main />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { AppMain, Navbar, Sidebar, TagsView } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { getNotifyAnnouncement } from '@/api/notify';
import { sources } from '@fingerprintjs/fingerprintjs';

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showNoticeBar: state => state.settings.showNoticeBar,
      noticeContent: state => state.settings.noticeContent,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      };
    },
  },
  created() {
    this.$store.dispatch('settings/getNotify');
  },
  mounted() {
    //快捷入口
    try {
      const myPlugin = new BottomRightPlugin();
      myPlugin.getQuickList('NYB');
    } catch (e) {
      console.log(e);
    }
    this.$store.dispatch('settings/setHeaderHeight');
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 980px;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - #{$sideBarWidth});
}

.mobile .fixed-header {
  width: 100%;
}
</style>
